const featuresIndex = {
	en: [
		{
			title: 'Website QA & Testing',
			info: `We will perform a session of 2 to 5 hours of Testing and Quality Assurance on the website. We look specifically for visual and functional bugs. We test the purchase flow to make sure the user doesn't experience any blockers when buying. On the StartUp, ScaleUp and Enterprise plans we run this monthly.`,
		},
		{
			title: 'Custom Development',
			info: `We build flexible, re-usable and scalable components for your website. We write clean and readable code and we integrate with existing components. We can build based on provided designs or we can get our designer to provide mockups.`,
		},
		{
			title: 'Bug Fixing',
			info: `All websites should be bug-free. We commit to finding and fixing any blockers, minor or major. We will provide reports and can also work on demand based on provided list of bugs.`,
		},
		{
			title: 'Support & Maintenance',
			info: `Custom website, Shopify store or any other platform - they all need to be kept an eye on on a monthly basis. We will cover any apps, plugins or theme updates and even take care of support communication for your brand.`,
		},
		{
			title: 'UX/UI Design',
			info: `We will design new components, landing pages, email campaigns or even give your website a fresh new look. We focus on web design that converts users into buyers or leads.`,
		},
		{
			title: 'Strategic Consulting',
			info: `Our team of experts will provide valuable advice to make sure your business grows further. We will provide support for choosing best partners, services or digital strategies, on various topics: SEO, CRO, Design, Developmnent.`,
		},
		{
			title: 'Dedicated Developer',
			info: `Available for our ScaleUp and Enterprise plan, this option gives you access to a developers from our team that focuses primarly on your success. They will integrate within your management and communication platforms and get going ASAP.`,
		},
		{
			title: 'Conversion Rate Optimisation Audit & Actioning',
			info: `With extended knowledge of industry standards, our team can run deep audits of your website focused on Lead Generation or Conversion Rate Optimisation. All reports include actionable tasks undertaken by our development or SEO teams.`,
		},
		{
			title: 'Data Analysis & Reports',
			info: `We collect data about your users activity and interaction using digital heat maps. We generate reports and tasks ready to be actioned by our team.`,
		},
		{
			title: 'Speed Optimisation',
			info: `We generate reports using best tools on the market: Google PageSpeed / Lighthouse, GTMetrix, WebPageTest. We find what's blocking your website and fix issues to enable its potential.`,
		},
		{
			title: 'Out of Office Hours Support',
			info: `When choosing the ScaleUp or Enterprise plan, you get direct access to our senior team members that are ready to go the extra mile when it comes to offering support outside of office hours.`,
		},
		{
			title: 'Monthly Strategic Planning and Brainstorm Meeting',
			info: `We run monthly meetings with stakeholders focused on how to make the most of what's on the market. You get access to a network of trusted partners offering various valuable services that can grow your business to higher levels.`,
		},
		{
			title: 'Technical Architecture Consulting',
			info: `Our senior developers have deep knowledge of what frameworks and technologies are best suited to your business. We leverage their expertise by creating the best technical architecture for your project.`,
		},
	],
	ro: [
		{
			title: 'Proactivitate',
			info: `Serviciu pro-activ de întreținere care asigură securitatea, stabilitatea și performanța magazinului Shopify. Reduceți costurile de mentenanță prin pachete lunare, trimestriale sau anuale și beneficiați de monitorizare 24/7, actualizări critice, backup-uri automate și rapoarte detaliate de performanță.`,
		},
		{
			title: 'Mentenanță și Suport',
			info: `Dezvoltăm componente modulare, reutilizabile și scalabile pentru website-ul dumneavoastră, folosind cod curat, documentat și ușor de întreținut. Integram cu arhitectura existentă sau livrăm designuri noi realizate de echipa noastră UX/UI, asigurând coerență vizuală și tehnică în întregul ecosistem.`,
		},
		{
			title: 'Corectarea Bug-urilor',
			info: `Ne angajăm să menținem un magazin fără erori prin audituri tehnice periodice și remedierea imediată a problemelor critice. Raportăm transparent fiecare bug, prioritizăm în funcție de impactul asupra conversiilor și oferim soluții rapide care elimină blocajele de vânzare.`,
		},
		{
			title: 'Suport și Mentenanță',
			info: `Acoperim toate actualizările lunare de aplicații, plugin-uri și teme, gestionăm comunicarea de suport cu terți și menținem platforma aliniată la cele mai noi standarde Shopify. Serviciul include monitorizare SLA, alerte în timp real și intervenții rapide fără întreruperi pentru clienți.`,
		},
		{
			title: 'Design UX/UI',
			info: `Concepem pagini de produs, landing-pages și template-uri de e-mail care transformă vizitatorii în clienți. Fie că este vorba de un refresh de brand sau de campanii sezoniere, punem accent pe design mobile-first, micro-interacțiuni și principii CRO pentru creșterea ratelor de conversie.`,
		},
		{
			title: 'Consultanță Strategică',
			info: `Obțineți acces la o echipă multidisciplinară (SEO, CRO, Design, Dev) care elaborează strategii data-driven menite să crească performanța eCommerce. Vă ghidăm în selecția celor mai potrivite tehnologii, parteneri și inițiative digitale pentru a accelera scalarea afacerii.`,
		},
		{
			title: 'Developer dedicat',
			info: `Disponibil în pachetele ScaleUp și Enterprise, un developer din echipa noastră se integrează în fluxul vostru de lucru, participă la sprinturi agile și livrează funcționalități la cerere. Veți beneficia de comunicare directă pe Slack/Jira și timp de reacție prioritar.`,
		},
		{
			title: 'Audit și Acțiune pentru Optimizarea Ratei de Conversie',
			info: `Realizăm audituri complete axate pe CRO și Lead Generation, combinând analize de funnel, heatmaps și teste A/B. Fiecare raport include un roadmap prioritar cu acțiuni implementabile de echipa noastră dev sau de marketing.`,
		},
		{
			title: 'Analiză de Date și Rapoarte',
			info: `Colectăm și interpretăm date comportamentale prin GA4, Hotjar și Shopify Analytics pentru a identifica oportunități de optimizare. Furnizăm rapoarte interactive și dashboard-uri ce permit decizii rapide și măsurabile.`,
		},
		{
			title: 'Optimizare Viteză',
			info: `Folosim Google Lighthouse, GTMetrix și WebPageTest pentru a diagnostica fiecare milisecundă pierdută. Optimizăm imagini, minificăm codul și configurăm CDN-uri astfel încât magazinul să atingă scoruri PageSpeed 90+ pe desktop și mobile.`,
		},
		{
			title: 'Suport în Afara Orelor de Lucru',
			info: `Pentru pachetele Enterprise oferim linie directă către echipa senioră, cu timp de răspuns sub 2 ore la solicitările critice, inclusiv în weekend și sărbători.`,
		},
		{
			title: 'Planificare Strategică și Reuniune de Brainstorming Lunară',
			info: `Organizăm sesiuni lunare cu stakeholder-ii pentru a identifica rapid tendințele de piață, oportunitățile de campanii și optimizările tehnice. Accesați rețeaua noastră extinsă de parteneri (plăți, logistică, marketing) pentru creștere accelerată.`,
		},
		{
			title: 'Consulting Arhitectură Tehnică',
			info: `Seniorii noștri arhitecți definesc cea mai potrivită infrastructură (headless, micro-services, ERP/CRM integrări) pentru nevoile voastre enterprise, asigurând scalabilitate și costuri operaționale optimizate.`,
		},
	],
};

export default featuresIndex;
